import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

import {mergeTo} from '#core/utils/config-utils.js';
import {bindAll} from '#core/utils/utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';
import {IMS_TYPES} from '#core/application/api/types.js';

import SCHEMA from './sports-segmentation.schema.yaml';

const {types: MessagingTypes, actions: messagingActions} = MojitoServices.Messaging;
const {INCOMING_MESSAGES} = MessagingTypes;
const {dispatch} = MojitoCore.Services.redux.store;

class PortalSportsSegmentationFeature extends AbstractFeature {
    constructor(parent) {
        super(parent);
        bindAll(this, 'handleUpdateTagsMessage', 'handleSetTagsMessage');
    }

    get name() {
        return 'Portal Sports Segmentation';
    }

    get configSchema() {
        return SCHEMA;
    }

    // Public Handler Method
    handleUpdateTagsMessage(data) {
        this.logger.debug('Received IMS_UPDATE_TAGS message.', data);

        if (Array.isArray(data)) {
            const priorityTags = data.filter(tag => tag.name === IMS_TYPES.PLAYER_TAGS.SPORT_RANK_ONE);

            if (priorityTags.length > 0) {
                priorityTags.forEach(tag => {
                    if (tag.removed) {
                        // If the tag was removed, dispatch null sportId
                        this.logger.debug('Dispatching removal message for Sport_Rank_One from Portal:', tag.name);
                        dispatch(
                            messagingActions.messageReceive({
                                ID: INCOMING_MESSAGES.RECEIVE_PRIORITY_SPORT,
                                payload: {
                                    name: tag.name,
                                    sportId: null, // Explicitly null for removal
                                },
                            })
                        );
                    } else if (tag.value) {
                        // If tag has a value, dispatch it
                        this.logger.debug(
                            'Dispatching update message for Sport_Rank_One from Portal:',
                            tag.name,
                            'with value:',
                            tag.value
                        );
                        dispatch(
                            messagingActions.messageReceive({
                                ID: INCOMING_MESSAGES.RECEIVE_PRIORITY_SPORT,
                                payload: {
                                    sportId: tag.value,
                                    name: tag.name,
                                },
                            })
                        );
                    }
                });
            }
        }
    }

    // Public Handler Method
    handleSetTagsMessage(data) {
        this.logger.debug('Received IMS_SET_TAGS message.', data);

        if (Array.isArray(data)) {
            const priorityTags = data.filter(tag => tag.name === IMS_TYPES.PLAYER_TAGS.SPORT_RANK_ONE);

            priorityTags.forEach(tag => {
                const submitMessage = {
                    ID: INCOMING_MESSAGES.RECEIVE_PRIORITY_SPORT,
                    payload: {
                        sportId: tag.value,
                        name: tag.name,
                    },
                };
                dispatch(messagingActions.messageReceive(submitMessage));
                this.logger.debug(
                    'Dispatched Sport_Rank_One message from Portal (IMS_SET_TAGS):',
                    tag.name,
                    'with value:',
                    tag.value
                );
            });
        }
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            PriorityType: {
                value: this.config.priorityType,
            },
        });

        if (!this.config.enabled) {
            this.logger.debug('Feature is disabled via configuration.');
        } else {
            this.logger.debug('Feature is enabled.');
        }

        super.updateViewsConfig(viewsConfig);
    }

    dispose() {
        this.logger.debug('Feature is disposed. No API message handlers to unregister here.');
        super.dispose();
    }
}

export const PortalSportsSegmentation = new PortalSportsSegmentationFeature(allFeatures);
